var count = 1;

$(document).ready(function(){
  var firstSelectedCountry = $('p.boldP').clone();
  $('.adjustDiv').append(firstSelectedCountry);


  var mq = window.matchMedia( "(max-width: 768px)" );
  mediaQueryJS(mq)
  mq.addListener(mediaQueryJS)

  $('.adjustDiv').click(function(){
    $('.adjustDiv').hide();
    $('.allStore').show();
    $('.mobileCountry').show();

  });

  $('.mobileCountry').click(function(e){
    var injectSelectedCountry = $('p.boldP').clone();
    $('.adjustDiv').empty();
    $('.adjustDiv').append(injectSelectedCountry);
    $('.allStore').hide();
    $('.adjustDiv').show();

  })

});

function mediaQueryJS(mq) {
    if (mq.matches) {
      $('.adjustDiv').css('display','block');
      $(".countryName").addClass('mobileCountry');
      $('p.notBoldP').addClass('d-none');
      $('p.notBoldP').removeClass('d-block');

    } else {
      $('.adjustDiv').css('display','none');
      $(".countryName").removeClass('mobileCountry');
      $('.countryName').addClass('d-block');
    }
}

function swapListMap(evt, choice){
  if ($(window).width() > 500) {
    if(choice == "List"){
      $('.storeMap').css({'visibility':'hidden', 'position':'absolute', 'opacity': '0'});
      $('#storeList').show();
      $(evt).addClass('active');
    }
    else{
      $('.storeMap').css({'visibility':'visible', 'position':'relative', 'opacity': '1'});
      $('#storeList').hide();
      $(evt).removeClass('active');
    }
  }
  if ($(window).width() <= 500) {
    // console.log('here hello?');
    if(choice == "List"){
      $('.storeMap').css({'display':'none', 'position':'absolute','opacity': '0'});
      $('#storeList').show();
      $(evt).addClass('active');
    }
    else{
      $('.storeMap').css({'display':'block', 'position':'relative', 'opacity': '1'});
      $('#storeList').hide();
      $(evt).removeClass('active');
    }
  }
}

function targetStore(evt) {
  var selected_country = $(evt).attr('data-country');
  var previous_country = $('p.boldP').attr('data-country');
  $('#countries-'+previous_country).addClass('d-none');
  $('#countries-'+previous_country).removeClass('d-block');
  $('#countries-'+selected_country).removeClass('d-none');
  $('#countries-'+selected_country).addClass('d-block');

  $('p.boldP').addClass('notBoldP');
  $('p.boldP').removeClass('boldP');
  $('#country-name-'+selected_country).removeClass('notBoldP');
  $('#country-name-'+selected_country).addClass('boldP');

}
